export const currency = value => {
  return numberToReal(parseFloat(value));
};

function numberToReal(numero) {
  return numero.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}
